import React from 'react';
import { TextField, TextFieldProps } from '@material-ui/core';

export default function ContatoInput(props: TextFieldProps) {
  return <TextField {...props} color="primary" variant="outlined" />;
}
